import { connect } from 'react-redux';
import {
  getCurrentActiveImageService,
  getCurrentFileService,
  getSelectedProject,
} from '../../../redux/projects/projects.selectors';

import { StoreState } from '../../../redux/reducers/store.types';

import { OwnProps, ResizedImage, StateProps } from './resized-image';
import { getSelectedOrganizationId } from '../../../selectors/organizations/organizations';

const mapStateToProps = (state: StoreState) => ({
  imageService: getCurrentActiveImageService(state),
  fileService: getCurrentFileService(state),
  project: getSelectedProject(state),
  organizationId: getSelectedOrganizationId(state),
});

export const ResizedImageContainer = connect<StateProps, {}, OwnProps>(
  mapStateToProps,
)(ResizedImage);
